//
// formatPhone
//

const formatPhone = (phone) => {
  const countries = {
    33: [1, 2, 2, 2, 2],
    1: [3, 3, 4],
  };

  if (!phone) return null;

  const phoneTxt = (typeof phone === 'string') ? phone : phone.toString();
  if (!phoneTxt.length) return '';

  let rslt = '+';

  const key = Object
    .keys(countries)
    .find((thisKey) => {
      const thisKeyTxt = thisKey.toString();
      // console.log(`phoneTxt=${phoneTxt}, thisKey=${thisKeyTxt} ${
      //   typeof phoneTxt} ${typeof thisKeyTxt}`);
      return (phoneTxt.startsWith(thisKeyTxt));
    });

  const mapArray = (key) ? [...countries[key]] : null;
  // console.log(`key=${key} mapArray=${mapArray}`);

  if (mapArray) {
    const keyTxt = key.toString();
    rslt += keyTxt;
    let current = keyTxt.length;

    while ((current < phoneTxt.length) && (mapArray.length)) {
      const size = mapArray.shift();
      const digits = phoneTxt.substring(current, current + size);
      current += size;
      rslt += ` ${digits}`;
    }

    if (current < phoneTxt.length) rslt += ` ${phoneTxt.substring(current)}`;
  } else {
    rslt += phoneTxt;
  }
  // console.log(rslt);

  return rslt;
};

export default formatPhone;
